
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Svg, Path } from 'react-native-svg';
import { useLanguage } from '../contexts/LanguageContext';

interface AuthorFilterContentProps {
  selectedAuthor: 'all' | 'user' | 'bill';
  onAuthorChange: (author: 'all' | 'user' | 'bill') => void;
}

export default function AuthorFilterContent({ selectedAuthor, onAuthorChange }: AuthorFilterContentProps) {
  const { t } = useLanguage();
  
  const authorOptions = [
    { id: 'user' as const, label: t('filters.author.you') },
    { id: 'bill' as const, label: t('filters.author.bill') },
  ];

  const handleOptionPress = (authorId: 'user' | 'bill') => {
    onAuthorChange(authorId);
  };

  return (
    <View style={styles.container}>
      {authorOptions.map((option) => (
        <TouchableOpacity
          key={option.id}
          style={[
            styles.optionCard,
            selectedAuthor === option.id && styles.selectedOptionCard
          ]}
          onPress={() => handleOptionPress(option.id)}
        >
          <Text style={styles.optionText}>{option.label}</Text>
          <View style={[
            styles.checkbox,
            selectedAuthor === option.id && styles.selectedCheckbox
          ]}>
            {selectedAuthor === option.id && (
              <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <Path 
                  d="M12.6654 4.7915L6.2487 11.2082L3.33203 8.2915" 
                  stroke="white" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                />
              </Svg>
            )}
          </View>
        </TouchableOpacity>
      ))}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: 8,
  },
  optionCard: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 20,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#F0EEE4',
    backgroundColor: '#F9F8F3',
    gap: 4,
  },
  selectedOptionCard: {
    borderColor: '#004165',
    backgroundColor: '#E6EBF0',
  },
  optionText: {
    flex: 1,
    fontSize: 14,
    fontFamily: 'Inter_400Regular',
    color: '#151515',
    lineHeight: 19.6,
  },
  checkbox: {
    width: 24,
    height: 24,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#7E7D75',
    backgroundColor: '#FFFFFF',
    justifyContent: 'center',
    alignItems: 'center',
  },
  selectedCheckbox: {
    borderWidth: 3,
    borderColor: '#015480',
    backgroundColor: '#015480',
    padding: 4,
  },
});
